import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices/DomainServicesContext";

import { CollectionRecord, UpdateCollectionRequest } from "../CollectionRecord";

import { getQueryKey } from "./useCollection";

interface UpdateCollectionVariables {
  collectionId: string;
  resourceOwnerId: string;
  updates: UpdateCollectionRequest;
}

export function useUpdateCollection() {
  const { collections } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<CollectionRecord, Error, UpdateCollectionVariables>({
    mutationFn: ({ collectionId, resourceOwnerId, updates }) =>
      collections.updateCollection(collectionId, updates, { resourceOwnerId }),
    onSuccess: (record) => {
      queryClient.setQueryData(getQueryKey(record.collection_id), record);
      void queryClient.invalidateQueries({
        queryKey: getQueryKey(record.collection_id),
      });
    },
  });
}
